import React from 'react'

import NavigationSection from "../../../../core/model2/navigation/navigation-section"
import ReorderList from "../../../../core/gd-ui/sortable-list-4/reorder-list"
import getNavigationButtonTypeClass from "../../actions/get-navigation-button-type-class";
import {ReorderListType} from "../../../../core/gd-ui/sortable-list-4/reorder-list-no-div";
import {UIType} from "../../../ui/@const";

type Props = {
    sections    : NavigationSection[],

    onDragEnd   : func
}

// const debug = "NavigationPanelReorderGroup"
const debug = false

export default function NavigationPanelReorderGroup(props: Props) {
    const topSectionsItems: any[] = []

    // If section is SPACE we can show navbar button like tab else
    _.map(props.sections, (section: NavigationSection)=>{

        const className = getNavigationButtonTypeClass(section)

        topSectionsItems.push({
            item        : section,
            component   : (
                <section.renderComponent
                    className   = {className}
                    section     = {section}
                />
            )
        })
    })

    const keyFunction = (item: NavigationSection, key: number) => {
        return '{0}-{1}'.f(item.id, key)
    }

    const listType = gd.ui.type === UIType.TOP ? ReorderListType.HORIZONTAL : ReorderListType.VERTICAL

    debug && console.log(debug, 'render', topSectionsItems)

    return (
        <ReorderList
            items       = {topSectionsItems}
            keyFunction = {keyFunction}
            onReorder   = {props.onDragEnd}
            type        = {listType}
        />
    )
}
